import React from 'react';
import { formatPhoneNumber } from '../../helper';

export default function ModalContentEmployee({ userData, resetPassword }) {
    return <>
        <div className="modal">
            <div className="modal-content">
                <h3>User Info</h3>
                <div className="text-blk">
                    <span className="label">
                        First Name:
                    </span>
                    <span className="value">
                        {userData.first_name ? userData.first_name : 'N/A'}
                    </span>
                </div>
                <div className="text-blk">
                    <span className="label">
                        Last Name:
                    </span>
                    <span className="value">
                        {userData.last_name ? userData.last_name : 'N/A'}
                    </span>
                </div>
                <div className="text-blk">
                    <span className="label">
                        Email:
                    </span>
                    <span className="value">
                        {userData.email ? userData.email : 'N/A'}
                    </span>
                </div>
                <div className="text-blk">
                    <span className="label">
                        Primary Phone:
                    </span>
                    <span className="value">
                        {userData.cell_phone ? formatPhoneNumber(userData.cell_phone) : 'N/A'}
                    </span>
                </div>
                <div className="text-blk">
                    <span className="label">
                        Secondary Phone:
                    </span>
                    <span className="value">
                        {userData.secondary_phone ? formatPhoneNumber(userData.secondary_phone) : 'N/A'}
                    </span>
                </div>
                <div className="text-blk">
                    <span className="label">
                        Account Locked:
                    </span>
                    <span className="value">
                        {userData.account_locked ? 'True' : 'False'}
                    </span>
                    <span style={{ cursor: 'pointer' }} className="reset-link" onClick={() => resetPassword && resetPassword(true)}>Reset Password</span>
                </div>
            </div>
        </div>
    </>
}